import { EmptyTab } from 'assets/images'
import TabStatusCard from 'components/TabStatusCard/Index'
import Button from 'components/Button/Index'
import { Container } from '@mui/material'
import { useSelector } from 'react-redux'
import { menuList } from 'features/menu/menu'
import { paymentEnableData } from 'features/restaurant/restaurant'
import { isOrderingEnabledAndHealthy } from 'utility/helper'
import { IRestaurantDetailData } from 'interfaces/restaurant'
import { JSX } from 'react'

interface EmptyTabViewProps {
  restaurantData: IRestaurantDetailData
  showPaymentDisabledMessage: boolean
  getStatusMessage: () => string
  getStatusSubMessage: () => JSX.Element | string
  emptyOrder?: boolean
}

const EmptyTabView = ({
  restaurantData,
  showPaymentDisabledMessage,
  getStatusMessage,
  getStatusSubMessage,
  emptyOrder = false,
}: EmptyTabViewProps) => {
  // Use centralized logic to determine ordering state and menu availability
  const menus = useSelector(menuList)
  const paymentEnable = useSelector(paymentEnableData)

  const hasMenus = menus && menus.length > 0
  const isOrderingEnabled = isOrderingEnabledAndHealthy(menus, paymentEnable)

  return (
    <>
      <TabStatusCard
        restaurantData={restaurantData}
        message={getStatusMessage()}
        subMessage={getStatusSubMessage()}
      />
      {!showPaymentDisabledMessage && (
        <>
          <img className="empty-tab-image" src={EmptyTab} alt="Empty Tab" />
          {/* Show footer buttons when tab is empty and menus are available */}
          {emptyOrder && hasMenus && (
            <footer className="footer mui-fixed">
              <Container maxWidth="md">
                <Button
                  variant="contained"
                  color="primary"
                  isTypeLink
                  to={isOrderingEnabled ? '/order-menu' : '/view-menu'}
                  title={isOrderingEnabled ? 'Order Now' : 'View Menu'}
                >
                  <span>{isOrderingEnabled ? 'Order Now' : 'View Menu'}</span>
                </Button>
              </Container>
            </footer>
          )}
        </>
      )}
    </>
  )
}

export default EmptyTabView
